import { useState } from "react";
import { Form } from "react-bootstrap";

import FileUploadButton from "../components/FileUploadButton";

function CuratorsPage() {
  const [currentBucket, setCurrentBucket] = useState("files");
  
  return (
    <>
      <div className="mx-5">
        <h2>Curation</h2>

        <p>Please select a destination for your uploads.</p>

        <Form.Group>
          <Form.Check
            inline
            type="radio"
            label="Database"
            name="bucketOptions"
            value="files"
            checked={currentBucket === "files"}
            onChange={(e) => setCurrentBucket(e.target.value)}
          />
          <Form.Check
            inline
            type="radio"
            label="Platinum"
            name="bucketOptions"
            value="platinum-files"
            checked={currentBucket === "platinum-files"}
            onChange={(e) => setCurrentBucket(e.target.value)}
          />
        </Form.Group>
        <Form.Text className="text-muted">
          {currentBucket === "platinum-files" ?
            "If scripts cannot be shared with the general public, upload them to Platinum." :
            "Only upload scripts to the main Database if they should be available to all users."
          }
        </Form.Text>

        <FileUploadButton bucket={currentBucket} />
      </div>
    </>
  );
}

export default CuratorsPage;